import { BundleIcon, ModifiersIcon, Typography } from '@weareopenr/component-library';
import { UseFormReturn } from 'react-hook-form';
import RadioButtonGroup, { type RadioButtonOptionProps } from '../../RadioButtonGroup';
import styles from '../CreateOptionGroupModal.module.scss';
import { OptionGroupType as OptionGroupTypeEnum } from '../../../constants';
import { IOptionGroupValues } from '../types';

interface OptionGroupTypeProps {
  useFormReturn: UseFormReturn<IOptionGroupValues>;
}

const modifierGroupOption: RadioButtonOptionProps = {
  option: OptionGroupTypeEnum.MODIFIER,
  label: 'Modifier Group',
  LogoComponent: () => <ModifiersIcon size="xlarge" />,
  toolTipText:
    'A group of products used as additions or extras for menu items. Modifier groups can only be added to standard or non-food items.',
};

const bundleGroupOption: RadioButtonOptionProps = {
  option: OptionGroupTypeEnum.BUNDLE,
  label: 'Bundle Group',
  LogoComponent: () => <BundleIcon size="xlarge" />,
  toolTipText:
    'A group of products used to build bundles such as meal deals or set menus. Bundle groups can only be added to bundle items.',
};

export const OptionGroupType = ({ useFormReturn }: OptionGroupTypeProps) => {
  const { control } = useFormReturn;

  return (
    <>
      <Typography weight="semi-bold" size="xxlarge" className={styles['heading-text']}>
        Option Group Type
      </Typography>
      <Typography>Select the type of group you wish to create</Typography>
      <RadioButtonGroup
        control={control}
        radioButtonGroupName="optionGroupType"
        radioOptions={[modifierGroupOption, bundleGroupOption]}
      />
    </>
  );
};
